import React from "react";
import { compose } from "redux";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import ButtonBase from "@material-ui/core/ButtonBase";
import Grid from "@material-ui/core/Grid";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import SvgIcon from "@material-ui/core/SvgIcon";
import LanguageMenu from "../components/LanguageMenu";
import SettingsMenu from "../components/SettingsMenu";
import NotificationsMenu from "../components/NotificationsMenu";
import withLocalization from "../hocs/withLocalization";
import Logo from "./Logo";
import HeaderMenu from "../components/HeaderMenu";

export const HEADER_HEIGHT = 75;
export const LOGO_WIDTH = 145;

const styles = (theme) => ({
    actions: {
        marginLeft: "auto",
        marginTop: "1rem",
        display: "flex",
        paddingRight: 16,
    },
    toolbarStyle: {
        boxSizing: "border-box",
        minHeight: HEADER_HEIGHT,
        height: HEADER_HEIGHT,
        backgroundColor: "#fff",
        padding: "8px 35px 12px 35px",
        alignItems: "flex-end",
    },
    logo: {
        position: "absolute",
        maxWidth: LOGO_WIDTH,
        fontFamily: "MANEurope, Arial, sans-serif",
        width: "100%",
        height: "auto",
        top: -5,
        right: 0,
    },
    container: {
        maxWidth: 1200,
        marginLeft: "auto",
        marginRight: "auto",
        position: "relative",
        height: "100%",
        paddingRight: LOGO_WIDTH,
        alignItems: "center",
    },
    siteTitleStyle: {
        color: "#838A92",
        fontFamily: "'MAN-light', Arial, sans-serif",
        lineHeight: "1.6",
        textRendering: "optimizeLegibility",
        letterSpacing: ".18px",
        fontWeight: 300,
        fontSize: 13,
        paddingBottom: 4,
    },
    infoButtonStyle: {
        padding: "5px 10px 2px 10px",
    },
});

const InfoIcon = () => (
    <SvgIcon viewBox="0 0 40 40" style={{ fontSize: 20 }}>
        <path
            fill="#303C49"
            d="M20,0C9,0,0,9,0,20c0,11,9,20,20,20s20-9,20-20C40,9,31,0,20,0z M20.8,7.2c1.8,0,3.3,1.5,3.3,3.3
    	s-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3S19,7.2,20.8,7.2z M26.1,31.2H15.5v-2.7h2.7v-9.3h-2.7v-2.7h2.7h5.3v2.7v9.3h2.7V31.2z"
        />
    </SvgIcon>
);

const HowToLink = (props) => <Link to="/how-to" {...props} />;

const Header = ({
    classes: { toolbarStyle, logo, container, siteTitleStyle, infoButtonStyle, actions },
    isLoggedIn,
    client,
}) => (
    <div style={{ paddingTop: HEADER_HEIGHT }}>
        <AppBar elevation={0} style={{}}>
            <Toolbar classes={{ root: toolbarStyle }} disableGutters>
                <Grid container alignItems="flex-end" className={container} spacing={0}>
                    <Logo className={logo} />
                    <div>
                        <Link to="/home" style={{ textDecoration: "none" }}>
                            <Typography className={siteTitleStyle}>MAN Products & Solutions</Typography>
                        </Link>
                        {isLoggedIn && <HeaderMenu />}
                    </div>
                    <div className={actions}>
                        {isLoggedIn && <NotificationsMenu newsSize={5} />}
                        {isLoggedIn && (
                            <ButtonBase
                                disableRipple
                                disableTouchRipple
                                component={HowToLink}
                                className={infoButtonStyle}
                            >
                                <InfoIcon />
                            </ButtonBase>
                        )}
                        <LanguageMenu />
                        {isLoggedIn && <SettingsMenu />}
                    </div>
                </Grid>
            </Toolbar>
        </AppBar>
    </div>
);

export default compose(withStyles(styles), withLocalization)(Header);



// WEBPACK FOOTER //
// ./src/layouts/Header.js